import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import backgroundImage from '../../assets/img/aquine.jpg';
import { BASE_URL } from '../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await axios.post(`${BASE_URL}/forgotPassword`, { email: email.trim() });
            setSent(true);
        } catch (err) {
            const msg = err.response?.data?.message || 'Error al enviar el correo. Intenta más tarde.';
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex">
            {/* Left side - Image */}
            <div
                className="hidden lg:flex lg:w-3/5 relative bg-cover bg-center"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
                <div className="absolute inset-0 bg-gradient-to-br from-primary-900/70 to-primary-600/70"></div>
                <div className="relative z-10 flex flex-col justify-center items-center text-white p-12">
                    <h1 className="text-5xl font-bold mb-4">Recuperar acceso</h1>
                    <p className="text-xl text-center max-w-md">Sistema de Control de Acceso</p>
                </div>
            </div>

            {/* Right side - Form */}
            <div className="flex-1 flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-8">

                    {/* Icon */}
                    <div className="text-center">
                        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-700 shadow-lg">
                            <FontAwesomeIcon icon={faEnvelope} className="h-8 w-8 text-white" />
                        </div>
                        <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                            ¿Olvidaste tu contraseña?
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Ingresa tu correo y te enviaremos las instrucciones
                        </p>
                    </div>

                    {sent ? (
                        /* Success state */
                        <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center space-y-4">
                            <FontAwesomeIcon icon={faCheckCircle} className="h-12 w-12 text-green-500 mx-auto" />
                            <h3 className="text-lg font-semibold text-green-800">Correo enviado</h3>
                            <p className="text-sm text-green-700">
                                Si el correo <strong>{email}</strong> está registrado, recibirás un enlace para restablecer tu contraseña.<br />
                                Revisa también tu carpeta de spam.
                            </p>
                            <Link
                                to="/login"
                                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors"
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                                Volver al inicio de sesión
                            </Link>
                        </div>
                    ) : (
                        /* Form */
                        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3">
                                    {error}
                                </div>
                            )}

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Correo Electrónico
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faEnvelope} className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="input-field pl-10 focus:border-primary-500"
                                        placeholder="correo@ejemplo.com"
                                    />
                                </div>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-semibold rounded-lg text-white gradient-bg hover:shadow-lg transform transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none"
                            >
                                {loading ? (
                                    <span className="flex items-center gap-2">
                                        <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                                        </svg>
                                        Enviando...
                                    </span>
                                ) : (
                                    'Enviar instrucciones'
                                )}
                            </button>

                            <div className="text-center">
                                <Link
                                    to="/login"
                                    className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors"
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    Volver al inicio de sesión
                                </Link>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
